import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=015dfe26&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015dfe26",
  null
  
)

export default component.exports